import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { selectCurrentCustomerId } from "modules/auth";
import { usePayment } from "modules/transactions";
import { selectGlobalFilteredCustomer } from "store/appSlice";

import { useRiskOverviewResponse } from "./useRiskOverviewResponse";

import type { ObjectWithId } from "utils/ObjectWithId";

export const useRiskOverview = () => {
  const { id } = useParams<ObjectWithId>();
  const { payment } = usePayment({ id });
  const riskOverviewData = useRiskOverviewResponse();
  const blockList = riskOverviewData.blockList;
  const riskScore = riskOverviewData.riskScore;
  const { score, threshold } = riskScore;
  const overallRisk = { score, threshold };
  const globalFilteredCustomer = useSelector(selectGlobalFilteredCustomer);
  const currentCustomerId = useSelector(selectCurrentCustomerId);
  const selectedItemCustomerId = payment?.beneficiary?.customerId;
  const currentId = currentCustomerId ?? globalFilteredCustomer?.id;

  const isSameCustomer =
    !currentId || !selectedItemCustomerId
      ? false
      : currentId === selectedItemCustomerId;

  return {
    isSameCustomer,
    blockList,
    riskScore,
    overallRisk,
  };
};
